export default "__VITE_ASSET__792e2f1c__"